export default __webpack_public_path__ + "static/media/ctnews_tablet_1.c38cc235.png";